import { render, staticRenderFns } from "./ShowcaseWrapper.vue?vue&type=template&id=00479490"
import script from "./ShowcaseWrapper.vue?vue&type=script&lang=js"
export * from "./ShowcaseWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports